export const actionTypes = {
  TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST",
  TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_SUCCESS:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_SUCCESS",
  TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_FAILURE:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_FAILURE",
  SET_SELECTED_APPLICATION_TEMPORARY_ABILITATIONS_MANAGEMENT:
    "SET_SELECTED_APPLICATION_TEMPORARY_ABILITATIONS_MANAGEMENT",
  TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST",
  TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_SUCCESS:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_SUCCESS",
  TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_FAILURE:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_FAILURE",
  MODIFY_ADDED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN:
    "MODIFY_ADDED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN",
  MODIFY_DELETED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN:
    "MODIFY_DELETED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN",
  MODIFY_TOTAL_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN:
    "MODIFY_TOTAL_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN",
  TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST",
  TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_SUCCESS:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_SUCCESS",
  TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_FAILURE:
    "TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_FAILURE",
  SAVE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST:
    "SAVE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST",
  SAVE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS:
    "SAVE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS",
  SAVE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE:
    "SAVE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE",
  CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST:
    "CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST",
  CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS:
    "CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS",
  CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE:
    "CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE",
  UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST:
    "UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST",
  UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS:
    "UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS",
  UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE:
    "UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE",
  FETCH_TEMPORARY_ENTITLEMENTS_REQUEST: "FETCH_TEMPORARY_ENTITLEMENTS_REQUEST",
  FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS:
    "FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS",
  FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE:
    "FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE",
  UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST:
    "UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST",
  UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS:
    "UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS",
  UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE:
    "UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE",
  SET_SELECTED_TEMPORARY_ENTITLEMENT_TEMPORARY_ABILITATIONS_MANAGEMENT:
    "SET_SELECTED_TEMPORARY_ENTITLEMENT_TEMPORARY_ABILITATIONS_MANAGEMENT",
  FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST:
    "FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST",
  FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_SUCCESS:
    "FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_SUCCESS",
  FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_FAILURE:
    "FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_FAILURE",
  FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST:
    "FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST",
  FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_SUCCESS:
    "FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_SUCCESS",
  FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_FAILURE:
    "FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_FAILURE",
  ADD_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST:
    "ADD_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST",
  REMOVE_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST:
    "REMOVE_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST",
  CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST:
    "CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST",
  CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS:
    "CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS",
  CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE:
    "CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE",
  DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST:
    "DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST",
  DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS:
    "DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS",
  DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE:
    "DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE",
  CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST:
    "CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST",
  CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS:
    "CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS",
  CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE:
    "CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE",
  MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST:
    "MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST",
  MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_SUCCESS:
    "MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_SUCCESS",
  MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_WARNING:
    "MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_WARNING",
  MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_FAILURE:
    "MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_FAILURE",
  RESET_TEMPORARY_ABILITATIONS_IN_APPLICATION_CONFIGURATION:
    "RESET_TEMPORARY_ABILITATIONS_IN_APPLICATION_CONFIGURATION",
  GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST:
    "GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST",
  GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_SUCCESS:
    "GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_SUCCESS",
  GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_FAILURE:
    "GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_FAILURE",
  GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST:
    "GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST",
  GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS:
    "GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS",
  GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE:
    "GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE",
  UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST:
    "UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST",
  UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS:
    "UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS",
  UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE:
    "UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE",
  RESET_STATE_TEMPORARY_ABILITATIONS_MANAGEMENT:
    "RESET_STATE_TEMPORARY_ABILITATIONS_MANAGEMENT",
  GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID:
    "GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID",
  GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_SUCCESS:
    "GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_SUCCESS",
  GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_FAILURE:
    "GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_FAILURE",
  FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG:
    "FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG",
  FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_SUCCESS:
    "FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_SUCCESS",
  FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_FAILURE:
    "FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_FAILURE",
  FETCH_EMERGENCY_ENTITLEMENT_REQUIRED: "FETCH_EMERGENCY_ENTITLEMENT_REQUIRED",
  FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_SUCCESS:
    "FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_SUCCESS",
  FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_FAILURE:
    "FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_FAILURE",
  SELECT_EMERGENCY_CONFIGURATION: "SELECT_EMERGENCY_CONFIGURATION",
  MODIFY_EMERGENCY_ADDED_ENTITLEMENTS: "MODIFY_EMERGENCY_ADDED_ENTITLEMENTS",
  MODIFY_EMERGENCY_DELETED_ENTITLEMENTS:
    "MODIFY_EMERGENCY_DELETED_ENTITLEMENTS",
  MODIFY_EMERGENCY_TOTAL_ENTITLEMENTS: "MODIFY_EMERGENCY_TOTAL_ENTITLEMENTS",
  RESET_EMERGENCY_ENTITLEMENTS_STATE: "RESET_EMERGENCY_ENTITLEMENTS_STATE",
};

export const temporaryAbilitationsManagementFetchApplicationsRequest = (
  payload: any
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST,
  payload,
});

export const temporaryAbilitationsManagementFetchApplicationsRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_SUCCESS,
  payload,
});

export const temporaryAbilitationsManagementFetchApplicationsRequestFailure = (
  err: Error
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_FAILURE,
  err,
});

export const setSelectedApplicationTemporaryAbilitationsManagement = (
  row: any
) => ({
  type: actionTypes.SET_SELECTED_APPLICATION_TEMPORARY_ABILITATIONS_MANAGEMENT,
  row,
});

export const temporaryAbilitationsManagementFetchAbilitationsRequest = (
  payload: any
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST,
  payload,
});

export const temporaryAbilitationsManagementFetchAbilitationsRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_SUCCESS,
  payload,
});

export const temporaryAbilitationsManagementFetchAbilitationsRequestFailure = (
  err: Error
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_FAILURE,
  err,
});

export const temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequest =
  (payload: any) => ({
    type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST,
    payload,
  });

export const temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequestSuccess =
  (payload: any) => ({
    type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_SUCCESS,
    payload,
  });

export const temporaryAbilitationsManagementGetSelectedApplicationConfigurationRequestFailure =
  (err: Error) => ({
    type: actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_FAILURE,
    err,
  });

export const getAutocompleteUser = () => ({
  type: actionTypes.GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID,
});

export const getAutocompleteUserSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_SUCCESS,
  payload,
});

export const getAutocompleteUserFailure = (err: Error) => ({
  type: actionTypes.GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_FAILURE,
  err,
});

export const createConfigurationApplicationTemporaryAbilitationsMgmt = (
  payload: any
) => ({
  type: actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST,
  payload,
});

export const createConfigurationApplicationTemporaryAbilitationsMgmtSuccess = (
  payload: any
) => ({
  type: actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS,
  payload,
});

export const createConfigurationApplicationTemporaryAbilitationsMgmtFailure = (
  err: Error
) => ({
  type: actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE,
  err,
});

export const updateConfigurationApplicationTemporaryAbilitationsMgmt = (
  payload: any
) => ({
  type: actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST,
  payload,
});

export const updateConfigurationApplicationTemporaryAbilitationsMgmtSuccess = (
  payload: any
) => ({
  type: actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationApplicationTemporaryAbilitationsMgmtFailure = (
  err: Error
) => ({
  type: actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE,
  err,
});

export const modifyAddedAbilitations = (payload: any) => ({
  type: actionTypes.MODIFY_ADDED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN,
  payload,
});

export const modifyDeletedAbilitations = (payload: any) => ({
  type: actionTypes.MODIFY_DELETED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN,
  payload,
});

export const modifyTotalAbilitations = (payload: any) => ({
  type: actionTypes.MODIFY_TOTAL_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN,
  payload,
});

export const fetchEmergencyGlobalCatalogAction = (payload: any) => ({
  type: actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG,
  payload,
});

export const fetchEmergencyGlobalCatalogActionSuccess = (payload: any) => ({
  type: actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_SUCCESS,
  payload,
});

export const fetchEmergencyGlobalCatalogActionFailure = (err: Error) => ({
  type: actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_FAILURE,
  err,
});

export const fetchEmergencyRequiredAction = (payload: any) => ({
  type: actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED,
  payload,
});

export const fetchEmergencyRequiredActionSuccess = (payload: any) => ({
  type: actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_SUCCESS,
  payload,
});

export const fetchEmergencyRequiredActionFailure = (err: Error) => ({
  type: actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_FAILURE,
  err,
});

export const modifyEmergencyAddedEntitlementsAction = (payload: []) => ({
  type: actionTypes.MODIFY_EMERGENCY_ADDED_ENTITLEMENTS,
  payload,
});

export const modifyEmergencyDeletedEntitlementsAction = (payload: []) => ({
  type: actionTypes.MODIFY_EMERGENCY_DELETED_ENTITLEMENTS,
  payload,
});

export const modifyEmergencyTotalEntitlementsAction = (payload: []) => ({
  type: actionTypes.MODIFY_EMERGENCY_TOTAL_ENTITLEMENTS,
  payload,
});

export const fetchTemporaryEntitlementsRequest = (payload: any) => ({
  type: actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST,
  payload,
});

export const fetchTemporaryEntitlementsRequestSuccess = (payload: any) => ({
  type: actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS,
  payload,
});

export const fetchTemporaryEntitlementsRequestFailure = (err: Error) => ({
  type: actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE,
  err,
});

export const updateTemporaryEntitlementsRequest = (payload: any) => ({
  type: actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST,
  payload,
});

export const updateTemporaryEntitlementsRequestSuccess = (payload: any) => ({
  type: actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS,
  payload,
});

export const updateTemporaryEntitlementsRequestFailure = (err: Error) => ({
  type: actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE,
  err,
});

export const setSelectedTemporaryEntitlementTemporaryAbilitationsManagement = (
  row: any
) => ({
  type: actionTypes.SET_SELECTED_TEMPORARY_ENTITLEMENT_TEMPORARY_ABILITATIONS_MANAGEMENT,
  row,
});

export const getRolesTemporaryEntitlementsConfigurationRequest = () => ({
  type: actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST,
});

export const getRolesTemporaryEntitlementsConfigurationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const getRolesTemporaryEntitlementsConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const addNewRoleTemporaryEntitlementsConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.ADD_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST,
  payload,
});

export const removeNewRoleTemporaryEntitlementsConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.REMOVE_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST,
  payload,
});

export const getTemporaryEntitlementConfigurationsRequest = (payload: any) => ({
  type: actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST,
  payload,
});

export const getTemporaryEntitlementConfigurationsRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_SUCCESS,
  payload,
});

export const getTemporaryEntitlementConfigurationsRequestFailure = (
  err: Error
) => ({
  type: actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_FAILURE,
  err,
});

export const createTemporaryEntitlementConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST,
  payload,
});

export const createTemporaryEntitlementConfigurationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const createTemporaryEntitlementConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const deleteTemporaryEntitlementConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST,
  payload,
});

export const deleteTemporaryEntitlementConfigurationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const deleteTemporaryEntitlementConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const createRoleTemporaryAbilitationConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST,
  payload,
});

export const createRoleTemporaryAbilitationConfigurationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const createRoleTemporaryAbilitationConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const getTemporaryAbilitationsAlreadySetOnApplicationRequest = () => ({
  type: actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST,
});

export const getTemporaryAbilitationsAlreadySetOnApplicationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_SUCCESS,
  payload,
});

export const getTemporaryAbilitationsAlreadySetOnApplicationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_FAILURE,
  err,
});

export const manageTemporaryAbilitationsInSelectedApplicationRequest = (
  payload: any
) => ({
  type: actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST,
  payload,
});

export const manageTemporaryAbilitationsInSelectedApplicationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_SUCCESS,
  payload,
});

export const manageTemporaryAbilitationsInSelectedApplicationRequestWarning = (
  payload: any
) => ({
  type: actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_WARNING,
  payload,
});

export const manageTemporaryAbilitationsInSelectedApplicationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_FAILURE,
  err,
});

export const getFieldsTemporaryAbilitationConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST,
  payload,
});

export const getFieldsTemporaryAbilitationConfigurationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const getFieldsTemporaryAbilitationConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const updateFieldsTemporaryAbilitationConfigurationRequest = (
  payload: any
) => ({
  type: actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST,
  payload,
});

export const updateFieldsTemporaryAbilitationConfigurationRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const updateFieldsTemporaryAbilitationConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const selectEmergencyConfigurationAction = (payload: any) => ({
  type: actionTypes.SELECT_EMERGENCY_CONFIGURATION,
  payload,
});

export const resetTemporaryAbilitationsInApplicationConfiguration = () => ({
  type: actionTypes.RESET_TEMPORARY_ABILITATIONS_IN_APPLICATION_CONFIGURATION,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE_TEMPORARY_ABILITATIONS_MANAGEMENT,
});

export const resetEmergencyEntitlementStateAction = () => ({
  type: actionTypes.RESET_EMERGENCY_ENTITLEMENTS_STATE,
});
